import { ar } from "element-plus/lib/locale";
import { BaseService, Service } from "/@/cool";

@Service("baseOpen")
class Open extends BaseService {

	wxH5AuthLogin(data: any) {
		return this.request({
			url: "/wxH5AuthLogin",
			method: "POST",
			data
		});
	}

	login(...args: any[]) {
		return this.userLogin(...args);
	}
	/**
	 * 用户登录
	 *
	 * @param {*} { username, password, captchaId, verifyCode }
	 * @returns
	 * @memberof CommonService
	 */
	userLogin({ username, password, captchaId, verifyCode }: any) {
		return this.request({
			url: "/login",
			method: "POST",
			data: {
				username,
				password,
				captchaId,
				verifyCode
			}
		});
	}

	wxlogin(data: any) {
		return this.request({
			url: "/wxLogin",
			method: "POST",
			data
		});
	}

	/**
	 * 图片验证码 svg
	 *
	 * @param {*} { height, width }
	 * @returns
	 * @memberof CommonService
	 */
	captcha({ height, width }: any) {
		return this.request({
			url: "/captcha",
			params: {
				height,
				width
			}
		});
	}

	/**
	 * 刷新 token
	 * @param {string} token
	 */
	refreshToken(token: string) {
		return this.request({
			url: "/refreshToken",
			params: {
				refreshToken: token
			}
		});
	}
}

export default Open;
